var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.roles.is_owner && ! _vm.roles.is_public)?_c('a',{staticClass:"tw-cursor-pointer text-danger hover:tw-text-red-dark tw-mr-6",on:{"click":_vm.deleteItem}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }